import { render } from "./CometChatUserPresence.vue?vue&type=template&id=09a222ae"
import script from "./CometChatUserPresence.vue?vue&type=script&lang=js"
export * from "./CometChatUserPresence.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__